import React, { useState } from 'react';
import classNames from 'classnames';
import { defineMessages, useIntl } from 'react-intl';

import ProductsMegaMenuTabLink from 'Layout/NavBar/MegaMenu/ProductsMegaMenuTabLink';
import ProductsMegaMenuTab from 'Layout/NavBar/MegaMenu/ProductsMegaMenuTab';

const messages = defineMessages({
  free_comic: {
    id: 'nav.fantasyverse-menu.freecomic',
    defaultMessage: 'Free Comic Book Day',
  },
  free_comic_text: {
    id: 'nav.fantasyverse-menu.freecomictext',
    defaultMessage: 'Celebrate Free Comic Book Day with exclusive deals and discover amazing comics for all ages.',
  },
  comic_graphic_novel: {
    id: 'nav.fantasyverse-menu.comicgraphicnovels',
    defaultMessage: 'Comic & Graphic Novels',
  },
  comic_graphic_novel_text: {
    id: 'nav.fantasyverse-menu.comicgraphicnoveltext',
    defaultMessage: 'Explore a wide range of comics and graphic novels, from timeless classics to modern masterpieces.',
  },
  manga: {
    id: 'nav.fantasyverse-menu.manga',
    defaultMessage: 'Manga',
  },
  manga_text: {
    id: 'nav.fantasyverse-menu.mangatext',
    defaultMessage: 'Dive into the world of manga with our curated collection of top titles and fan favorites.',
  },
  tabletop: {
    id: 'nav.fantasyverse-menu.tabletop',
    defaultMessage: 'Tabletop & RPG',
  },
  tabletop_text: {
    id: 'nav.fantasyverse-menu.tabletop_text',
    defaultMessage: 'Unleash your imagination with tabletop games, perfect for game nights and creative adventures.',
  },
  all_products: {
    id: 'nav.fantasyverse-menu.allproducts',
    defaultMessage: 'All Products',
  },
  all_products_text: {
    id: 'nav.fantasyverse-menu.allproductstext',
    defaultMessage: 'Browse our full collection of games, books, software, and more for every interest and passion.',
  },
});

function FantasyVerseMegaMenu({
  megaMenuTab = '',
  setMegaMenuTab = () => { },
  fantasyVerseComicBookDay,
  fantasyVerseComicsAndGraphicNovels = [],
  fantasyVerseManga = [],
  fantasyVerseTableTopRPG = [],
  fantasyVerseTopSellers = [],
}) {
  const contentArray = [
    { key: 'fantasyVerseComicBookDay', hits: fantasyVerseComicBookDay },
    { key: 'fantasyVerseComicsAndGraphicNovels', hits: fantasyVerseComicsAndGraphicNovels },
    { key: 'fantasyVerseManga', hits: fantasyVerseManga },
    { key: 'fantasyVerseTableTopRPG', hits: fantasyVerseTableTopRPG },
    { key: 'fantasyVerseTopSellers', hits: fantasyVerseTopSellers },
  ];

  const defaultTabString = contentArray.find(({ hits }) => hits?.length > 0)?.key || '';

  const [tab, setTab] = useState(defaultTabString);

  const { formatMessage } = useIntl();

  const toggleTab = (newTab) => {
    if (tab !== newTab) {
      setTab(newTab);
    }
  };

  const hideDropDown = contentArray.every(({ hits }) => hits?.length === 0);

  if (hideDropDown) return false;

  return (
    <div
      id="MegaMenu_fantasyVerse"
      className="container MegaMenuContainer MegaMenuContainer__fantasyVerse"
      onMouseEnter={() => setMegaMenuTab('fantasyVerse')}
      onMouseLeave={() => setMegaMenuTab('')}
    >
      <div className={classNames('MegaMenu', { 'MegaMenu--visible': megaMenuTab === 'fantasyVerse' })}>
        <div className="ProductsMegaMenu">
          <div className="ProductsMegaMenu__tabLinks">
            <ul className="ProductsMegaMenu__linksContainer" role="menu" id="MegaMenu_fantasyVerse">
              {fantasyVerseComicBookDay?.length > 0 &&
                <ProductsMegaMenuTabLink name={formatMessage(messages.free_comic)} link="/fantasyverse" tab={tab} toggle={toggleTab} tabId="fantasyVerseComicBookDay" from="fantasyVerse" setMegaMenuTab={setMegaMenuTab} />
              }
              {fantasyVerseComicsAndGraphicNovels?.length > 0 &&
                <ProductsMegaMenuTabLink name={formatMessage(messages.comic_graphic_novel)} link="/fantasyverse" tab={tab} toggle={toggleTab} tabId="fantasyVerseComicsAndGraphicNovels" from="fantasyVerse" setMegaMenuTab={setMegaMenuTab} />
              }
              {fantasyVerseManga?.length > 0 &&
                <ProductsMegaMenuTabLink name={formatMessage(messages.manga)} link="/fantasyverse" tab={tab} toggle={toggleTab} tabId="fantasyVerseManga" from="fantasyVerse" setMegaMenuTab={setMegaMenuTab} />
              }
              {fantasyVerseTableTopRPG?.length > 0 &&
                <ProductsMegaMenuTabLink name={formatMessage(messages.tabletop)} link="/fantasyverse" tab={tab} toggle={toggleTab} tabId="fantasyVerseTableTopRPG" from="fantasyVerse" setMegaMenuTab={setMegaMenuTab} />
              }
              {fantasyVerseTopSellers?.length > 0 &&
                <ProductsMegaMenuTabLink name={formatMessage(messages.all_products)} link="/fantasyverse" tab={tab} toggle={toggleTab} tabId="fantasyVerseTopSellers" from="fantasyVerse" setMegaMenuTab={setMegaMenuTab} />
              }
            </ul>
          </div>
          {fantasyVerseComicBookDay?.length > 0 &&
            <ProductsMegaMenuTab
              tab={tab}
              title={formatMessage(messages.free_comic)}
              hits={fantasyVerseComicBookDay}
              setMegaMenuTab={setMegaMenuTab}
              section={'fantasyVerseComicBookDay'}
              linkTo={'/fantasyverse'}
              subText={formatMessage(messages.free_comic_text)}
            />
          }

          {fantasyVerseComicsAndGraphicNovels?.length > 0 &&
            <ProductsMegaMenuTab
              tab={tab}
              title={formatMessage(messages.comic_graphic_novel)}
              hits={fantasyVerseComicsAndGraphicNovels}
              setMegaMenuTab={setMegaMenuTab}
              section={'fantasyVerseComicsAndGraphicNovels'}
              linkTo={'/fantasyverse'}
              subText={formatMessage(messages.comic_graphic_novel_text)}
            />
          }

          {fantasyVerseManga?.length > 0 &&
            <ProductsMegaMenuTab
              tab={tab}
              title={formatMessage(messages.manga)}
              hits={fantasyVerseManga}
              setMegaMenuTab={setMegaMenuTab}
              section={'fantasyVerseManga'}
              linkTo={'/fantasyverse'}
              subText={formatMessage(messages.manga_text)}
            />
          }

          {fantasyVerseTableTopRPG?.length > 0 &&
            <ProductsMegaMenuTab
              tab={tab}
              title={formatMessage(messages.tabletop)}
              hits={fantasyVerseTableTopRPG}
              setMegaMenuTab={setMegaMenuTab}
              section={'fantasyVerseTableTopRPG'}
              linkTo={'/fantasyverse'}
              subText={formatMessage(messages.tabletop_text)}
            />
          }

          {fantasyVerseTopSellers?.length > 0 &&
            <ProductsMegaMenuTab
              tab={tab}
              title={formatMessage(messages.all_products)}
              hits={fantasyVerseTopSellers}
              setMegaMenuTab={setMegaMenuTab}
              section={'fantasyVerseTopSellers'}
              linkTo={'/fantasyverse'}
              subText={formatMessage(messages.all_products_text)}
            />
          }
        </div>
      </div>
    </div>
  );
}

export default FantasyVerseMegaMenu;
